export default function PillLink({ data }) {
  return (
    <ul className="pill-link-wrapper w-100 fx fx--w to-top">
      {data.map((pillLink, idx) => (
        <li
          key={idx}
          className="ps-r bc-white pv-1 pl-6-d pr-6-d pl-2 pr-2 bold"
          onClick={
            pillLink.href === "#" ? (e) => e.preventDefault() : undefined
          }
        >
          <p className="text--md-d text--sm">{pillLink.text}</p>
          <a className="full" href={pillLink.href}></a>
        </li>
      ))}
      <style jsx>{`
        .pill-link-wrapper {
          gap: 24px;
        }
        @media (max-width: 1200px) {
          .pill-link-wrapper {
            gap: 16px;
          }
        }
        .pill-link-wrapper li {
          border: 1px solid #e2e2e7;
          border-radius: 6px;
        }
        .pill-link-wrapper li:hover {
          box-shadow: 0 0 3px 0 rgba(51, 57, 61, 0.04),
            0 2px 8px 0 rgba(51, 57, 61, 0.09);
        }
        .pill-link-wrapper li:hover p {
          color: #3270d8;
        }
      `}</style>
    </ul>
  );
}
